import { render, staticRenderFns } from "./ModalAjuda.vue?vue&type=template&id=e964555c&scoped=true"
import script from "./ModalAjuda.vue?vue&type=script&lang=js"
export * from "./ModalAjuda.vue?vue&type=script&lang=js"
import style0 from "./ModalAjuda.vue?vue&type=style&index=0&id=e964555c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e964555c",
  null
  
)

export default component.exports